import MaterialSwitch from '@material-ui/core/Switch';
import React, { forwardRef } from 'react';

export default forwardRef(({ color = 'primary', ...props }, ref) => (
  <MaterialSwitch color={color} ref={ref} {...props} />
));
